import { initializeApp, getApps } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage, connectStorageEmulator } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Local development only: `REACT_APP_USE_EMULATORS=true npm start` talks to the Firebase
// emulators (firebase emulators:start) instead of the live project. Off unless that variable is set.
export const USING_EMULATORS = process.env.REACT_APP_USE_EMULATORS === 'true';
if (USING_EMULATORS && !globalThis.__rcEmulatorsConnected) {
  globalThis.__rcEmulatorsConnected = true;
  connectAuthEmulator(getAuth(app), 'http://127.0.0.1:9099', { disableWarnings: true });
  connectFirestoreEmulator(db, '127.0.0.1', 8080);
  connectStorageEmulator(storage, '127.0.0.1', 9199);
  connectFunctionsEmulator(getFunctions(app, 'us-central1'), '127.0.0.1', 5001);
}

let analytics = null;
if (typeof window !== 'undefined' && firebaseConfig.measurementId && !USING_EMULATORS) {
  try {
    analytics = getAnalytics(app);
  } catch (_) {}
}
export { analytics };

export default app;
